import React from "react";
import { Loader2 } from "lucide-react";
import { Button } from "../ui/button";

interface SubmitButtonProps {
  isSubmitting: boolean;
}

const SubmitButton = ({ isSubmitting }: SubmitButtonProps) => {
  return (
    <Button
      type="submit"
      disabled={isSubmitting}
      className="w-full bg-tamayouz-blue hover:bg-tamayouz-dark-blue text-white py-3 rounded-lg transition-all duration-200 disabled:opacity-70 disabled:cursor-not-allowed font-verona"
    >
      {isSubmitting ? (
        <span className="inline-flex items-center font-verona">
          <Loader2 className="w-4 h-4 mr-2 animate-spin" />
          Submitting...
        </span>
      ) : (
        <span className="font-verona">Submit Application</span>
      )}
    </Button>
  );
};

export default SubmitButton;
